import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";

export const ActionTrabalhador = ({dispatch},payload)=>{
    return serves.aviso.trabalhador(payload).then(res => {
        dispatch('ActionSetTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetTrabalhador',err)
    })
}
export const ActionTomador = ({dispatch},payload)=>{
    return serves.aviso.tomador(payload).then(res => {
        dispatch('ActionSetTomador',res)
    }).catch(err => {
        dispatch('ActionSetTomador',err)
    })
}
export const ActionAniversario = ({dispatch},payload)=>{
    return serves.aviso.aniversario(payload).then(res => {
        dispatch('ActionSetAniversario',res)
    }).catch(err => {
        dispatch('ActionSetAniversario',err)
    })
}
export const ActionListaHistorico = ({dispatch},payload)=>{
    return serves.aviso.listahistorico(payload).then(res => {
        dispatch('ActionSetListaHistorico',res)
    }).catch(err => {
        dispatch('ActionSetListaHistorico',err)
    })
}
export const ActionSetTrabalhador = ({commit},payload) =>{
    commit(types.SET_TRABALHADOR,payload)
}
export const ActionSetTomador = ({commit},payload) =>{
    commit(types.SET_TOMADOR,payload)
}
export const ActionSetAniversario = ({commit},payload) =>{
    commit(types.SET_ANIVERSARIO,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetListaHistorico = ({commit},payload) =>{
    commit(types.SET_LISTAHISTORICO,payload)
}

